<!--
  艾斯达 Asstar 官网 - 关于我们（v4，内容来源：公司介绍 PPT）
-->
<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 关于我们</p>
        <h1>关于我们</h1>
        <p class="lede">北京艾斯达科技有限公司（ASSTAR）· AIoT 全链路技术服务商</p>
      </div>
    </section>

    <!-- 公司概览 -->
    <div class="ui-container">
      <div class="float-panel intro">
        <div class="intro__text">
          <span class="kicker">COMPANY PROFILE</span>
          <h2>创新驱动，客户至上</h2>
          <p class="intro__desc">{{ aboutIntro }}</p>
          <ul class="intro__facts">
            <li><b>全栈式</b><span>物联网 · 人工智能 · AR 交互 · 智能硬件定制</span></li>
            <li><b>闭环</b><span>硬件 — 云端 — 应用 — 生态</span></li>
            <li><b>一体化</b><span>从研发到落地的一体化数智化解决方案</span></li>
          </ul>
        </div>
        <div class="intro__badge">
          <span class="intro__badge-en">AIoT FULL-LINK</span>
          <span class="intro__badge-zh">技术服务商</span>
        </div>
      </div>
    </div>

    <!-- 价值观 -->
    <section class="section">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">VALUES</span>
          <h2>核心价值观</h2>
        </div>
        <div class="vals">
          <div class="val card" v-for="v in values" :key="v.name">
            <h3>{{ v.name }}</h3>
            <p>{{ v.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 使命与愿景 -->
    <section class="mission">
      <div class="ui-container">
        <div class="mission__grid">
          <div class="mission__card" v-for="c in culture" :key="c.name">
            <span class="mission__en">{{ c.en }}</span>
            <h3>{{ c.name }}</h3>
            <p>{{ c.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作模式 -->
    <section class="section">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">COOPERATION</span>
          <h2>合作模式与价值</h2>
          <p class="sub">灵活共赢，降低成本，共创商业价值</p>
        </div>
        <div class="coop-grid">
          <div class="coop card" v-for="(c, i) in cooperationModes" :key="c.name">
            <span class="coop__num">0{{ i + 1 }}</span>
            <h3>{{ c.name }}</h3>
            <p>{{ c.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型案例 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">CASES</span>
          <h2>典型落地案例</h2>
          <p class="sub">深耕行业，创造价值</p>
        </div>
        <div class="case-grid">
          <div class="case card" v-for="c in cases" :key="c.name">
            <div class="case__pic">
              <img :src="c.image" :alt="c.name" />
              <span class="tag tag--solid case__tag">{{ c.tag }}</span>
            </div>
            <div class="case__body">
              <h3>{{ c.name }}</h3>
              <p>{{ c.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">CONTACT US</span>
          <h2>联系我们</h2>
          <p class="sub">期待与您共创数智未来</p>
        </div>
        <div class="contact__panel card">
          <div class="contact__info">
            <div class="contact__row">
              <span class="icon-dot contact__icon">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 21s-7-5.2-7-11a7 7 0 0114 0c0 5.8-7 11-7 11z" /><circle cx="12" cy="10" r="2.6" />
                </svg>
              </span>
              <div>
                <h4>公司地址</h4>
                <p>{{ contact.address }}</p>
              </div>
            </div>
            <div class="contact__row">
              <span class="icon-dot contact__icon">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 4h4l2 5-2.5 1.5a12 12 0 005 5L15 13l5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z" />
                </svg>
              </span>
              <div>
                <h4>客服电话（{{ contact.hotlineTime }}）</h4>
                <p class="contact__phone">{{ contact.hotline }}</p>
              </div>
            </div>
            <div class="contact__mails">
              <div class="contact__mail" v-for="m in contact.emails" :key="m.value">
                <h4>{{ m.label }}</h4>
                <a :href="'mailto:' + m.value">{{ m.value }}</a>
              </div>
            </div>
          </div>
          <div class="contact__qr">
            <img :src="contact.qrcode" :alt="contact.qrcodeLabel" />
            <span>{{ contact.qrcodeLabel }}</span>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { aboutIntro, values, culture, cooperationModes, cases, contactInfo } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        aboutIntro,
        values,
        culture,
        cooperationModes,
        cases,
        contact: contactInfo
      };
    }
  };
</script>

<style scoped>
  .intro { display: flex; align-items: center; gap: 40px; }
  .intro__text { flex: 1; }
  .intro__text h2 { margin-top: 8px; font-size: 26px; }
  .intro__desc {
    margin-top: 14px;
    font-size: 15px;
    line-height: 2;
    color: #4c515b;
    max-width: 720px;
  }
  .intro__facts {
    display: flex;
    gap: 32px;
    margin-top: 22px;
    padding-top: 22px;
    border-top: 1px solid #f2f3f5;
  }
  .intro__facts b {
    display: block;
    color: #e8382f;
    font-size: 17px;
  }
  .intro__facts span {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    color: #8a909b;
  }

  .intro__badge {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    background: var(--red-grad);
    color: #fff;
    box-shadow: var(--shadow-pop);
  }
  .intro__badge-en {
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.08em;
  }
  .intro__badge-zh {
    margin-top: 6px;
    font-size: 17px;
    font-weight: 600;
  }

  .vals {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  .val { padding: 26px 24px; text-align: center; }
  .val h3 { font-size: 17px; color: #e8382f; }
  .val p {
    margin-top: 10px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  .mission { padding: 12px 0 40px; }
  .mission__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 22px;
  }
  .mission__card {
    background: var(--red-grad);
    border-radius: var(--r-lg);
    color: #fff;
    padding: 36px 34px;
    position: relative;
    overflow: hidden;
  }
  .mission__card::after {
    content: "";
    position: absolute;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    right: -70px;
    bottom: -110px;
  }
  .mission__en {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.18em;
    color: rgba(255, 255, 255, 0.75);
  }
  .mission__card h3 {
    margin-top: 8px;
    font-size: 24px;
  }
  .mission__card p {
    margin-top: 12px;
    font-size: 14px;
    line-height: 2;
    color: rgba(255, 255, 255, 0.9);
    position: relative;
    z-index: 1;
  }

  .coop-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }
  .coop { padding: 28px 26px; }
  .coop__num {
    font-size: 30px;
    font-weight: 800;
    color: #f6b6b0;
  }
  .coop h3 { margin-top: 8px; font-size: 17px; }
  .coop p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  .case-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  .case { padding: 0; overflow: hidden; }
  .case__pic {
    position: relative;
    height: 150px;
    overflow: hidden;
  }
  .case__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.35s ease;
  }
  .case:hover .case__pic img { transform: scale(1.05); }
  .case__tag {
    position: absolute;
    left: 12px;
    top: 12px;
  }
  .case__body { padding: 18px 20px 22px; }
  .case__body h3 { font-size: 16px; }
  .case__body p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  .contact { padding: 0 0 84px; }
  .contact__panel {
    display: flex;
    align-items: stretch;
    gap: 40px;
    padding: 40px 44px;
  }
  .contact__info { flex: 1; }
  .contact__row {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }
  .contact__row + .contact__row { margin-top: 22px; }
  .contact__icon {
    width: 44px;
    height: 44px;
    background: #fdeceb;
    color: #e8382f;
    flex: none;
  }
  .contact__row h4 {
    font-size: 14px;
    color: #8a909b;
    font-weight: 500;
  }
  .contact__row p {
    margin-top: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #23262d;
  }
  .contact__phone { letter-spacing: 0.04em; }

  .contact__mails {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 28px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #f2f3f5;
  }
  .contact__mail h4 {
    font-size: 13px;
    color: #8a909b;
    font-weight: 500;
  }
  .contact__mail a {
    display: inline-block;
    margin-top: 4px;
    font-size: 15px;
    font-weight: 600;
    color: #e8382f;
  }
  .contact__mail a:hover { text-decoration: underline; }

  .contact__qr {
    flex: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 10px;
    border-left: 1px solid #f2f3f5;
  }
  .contact__qr img {
    width: 150px;
    height: 150px;
    border-radius: 14px;
    border: 1px solid #f2f3f5;
  }
  .contact__qr span {
    font-size: 13px;
    color: #8a909b;
  }

  /* ---------- 响应式 ---------- */
  @media (max-width: 1023px) {
    .intro { flex-direction: column; gap: 28px; align-items: flex-start; }
    .intro__badge { width: 140px; height: 140px; }
    .intro__facts { gap: 20px; flex-wrap: wrap; }
    .vals { grid-template-columns: repeat(2, 1fr); }
    .coop-grid { grid-template-columns: repeat(2, 1fr); }
    .case-grid { grid-template-columns: repeat(2, 1fr); }
    .contact__panel { padding: 28px 28px; gap: 28px; }
    .contact__qr img { width: 130px; height: 130px; }
  }

  @media (max-width: 767px) {
    .intro__text h2 { font-size: 22px; }
    .intro__facts { flex-direction: column; gap: 16px; }
    .intro__badge { display: none; }
    .vals { grid-template-columns: 1fr; gap: 14px; }
    .val { padding: 20px 18px; }
    .mission__grid { grid-template-columns: 1fr; }
    .mission__card { padding: 28px 24px; }
    .mission__card h3 { font-size: 20px; }
    .coop-grid { grid-template-columns: 1fr; }
    .case-grid { grid-template-columns: 1fr; }
    .case__pic { height: 140px; }
    .contact { padding-bottom: 56px; }
    .contact__panel { flex-direction: column; padding: 24px 20px; gap: 24px; }
    .contact__mails { grid-template-columns: 1fr; }
    .contact__qr {
      border-left: none;
      border-top: 1px solid #f2f3f5;
      padding-top: 24px;
      padding-left: 0;
      flex-direction: row;
      gap: 16px;
    }
    .contact__qr img { width: 110px; height: 110px; }
  }
</style>
